module.exports = {"content":{},"productInfo":{"code":"{3DE36689-D940-4B7E-9272-E1B1480A37B4}","name":"ポーランド語　初中級","serialHead":"NPAVS","courseResourceIDs":[{"levelNo":1,"resourceID":"ea892114a2481786c012381bfa141f79857e4673"},{"levelNo":2,"resourceID":"a6e6ed29235accdab4b24340eb4d84660fb0bc9a"},{"levelNo":3,"resourceID":"19a1b9e94506c2856f6aa42d0dcc18853f66772d"}],"language":"pl-PL","challengeCount":21874},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1